



























import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Jumbo extends Vue {
  
  @Prop({ type: String }) title!: string
  @Prop({ type: String }) subtitle?: string
  @Prop({ type: String }) ctaText?: string
  @Prop({ type: Object }) ctaTo?: {
    name: string
    params: any
  }
  @Prop({ type: String }) color!: string
  @Prop({ type: String }) imageSrc?: string
  @Prop({ default: .5 }) ratio!: number

  get md() {
    return Math.round(12 * this.ratio)
  }

  get gradient() {
    let color
    let gradient = false
    switch (this.color) {
      case 'primary':
        color = 'secondary'
        gradient = true
        break
      case 'secondary':
        color = 'secondary'
        break
    }
    return gradient ? `gradient-text gradient-${color}` : `${this.color}--text`
  }

  get imageWidth() {
    if (!this.imageSrc) return '100%'
    return this.$vuetify.breakpoint.smAndDown
      ? '60%'
      : (this.$vuetify.breakpoint.mdAndDown ? '100%' : '80%')
  }

}
